export const styles = {
	options: {
		zIndex: 10000,
		primaryColor: '#000',
	},
};
